import React from "react";

/**
 * BrandTagline — la signature Gively (les 3 piliers) sous le logo.
 *
 * Demande Lucas : TOUT en noir (pas de mots colorés), PAS de tiret, et une
 * « calligraphie digne d'une agence de design ».
 *
 * Parti pris typographique (sobre & premium, sans dépendance de police nouvelle —
 * on reste sur Manrope, la police de marque) :
 *   - mesure de ligne confortable (~34ch) pour un rythme de lecture agréable ;
 *   - `text-wrap: balance` + `pretty` : pas de lignes bancales ni de mots orphelins ;
 *   - interlignage généreux (1.55) + tracking optique légèrement négatif sur le
 *     texte courant (élégance des grandes/moyennes tailles) ;
 *   - hiérarchie par le POIDS et la TAILLE (pas par la couleur) : l'offre en
 *     semi-bold, la promesse solidaire en medium plus discret ;
 *   - tout en encre sombre #0f172a (noir « designer », plus raffiné que le #000 pur).
 *
 * Réutilisable (splash, hero d'accueil, footer…). Props : size, align, className.
 */
const INK = "#0f172a";

export default function BrandTagline({ size = 18, align = "center", className = "", style = {} }) {
  return (
    <div
      className={className}
      style={{
        maxWidth: `${34}ch`,
        margin: "0 auto",
        textAlign: align,
        fontFamily: "Manrope, Inter, sans-serif",
        color: INK,
        // text-wrap moderne : équilibre les lignes et évite les orphelins.
        textWrap: "balance",
        WebkitFontSmoothing: "antialiased",
        ...style,
      }}
    >
      <p
        style={{
          margin: 0,
          fontSize: size,
          fontWeight: 600,
          lineHeight: 1.5,
          letterSpacing: "-0.012em",
        }}
      >
        Achetez, vendez et louez vos objets de seconde main, proposez des services.
      </p>
      <p
        style={{
          margin: `${Math.round(size * 0.55)}px 0 0`,
          fontSize: Math.round(size * 0.8),
          fontWeight: 500,
          lineHeight: 1.55,
          letterSpacing: "-0.006em",
          color: INK,
          textWrap: "pretty",
        }}
      >
        Une part de chaque transaction finance l’association de votre choix.
      </p>
    </div>
  );
}
